function applyLazyImagePlaceholder(el) {
  const width = el.getAttribute('width')
  const height = el.getAttribute('height')
  if (width && height) {
    el.style.aspectRatio = `${width} / ${height}`
  }
}

function markLazyImageLoaded(el) {
  el.classList.remove('is-swiper-lazy-loading')
}

export function prepareLazyImagePlaceholders(swiper) {
  swiper.el?.querySelectorAll('img[data-src]').forEach(applyLazyImagePlaceholder)
}

/** Visible slides, plus the single slide that follows the last visible one. */
export function shouldLoadSlideImage(slide) {
  if (slide.classList.contains('swiper-slide-visible')) return true
  const previous = slide.previousElementSibling
  return Boolean(
    previous?.classList.contains('swiper-slide')
    && previous.classList.contains('swiper-slide-visible'),
  )
}

/** Copy data-src / data-srcset onto src for visible slides and the next one. */
export function hydrateVisibleSlideImages(swiper) {
  swiper.slides?.forEach((slide) => {
    if (!shouldLoadSlideImage(slide)) return
    slide.querySelectorAll('[data-srcset]').forEach((el) => {
      el.setAttribute('srcset', el.getAttribute('data-srcset'))
      el.removeAttribute('data-srcset')
    })
    slide.querySelectorAll('[data-src]').forEach((el) => {
      const src = el.getAttribute('data-src')
      if (!src) return
      applyLazyImagePlaceholder(el)
      el.classList.add('is-swiper-lazy-loading')
      el.addEventListener('load', () => markLazyImageLoaded(el), { once: true })
      el.addEventListener('error', () => markLazyImageLoaded(el), { once: true })
      el.setAttribute('src', src)
      el.removeAttribute('data-src')
      if (el.complete) {
        markLazyImageLoaded(el)
      }
    })
  })
}
